<cmps-wait-status
    [srStatus]="'Loading ' + config.title"
    *ngIf="hasPendingData"
></cmps-wait-status>
<div *ngIf="!hasPendingData && data == null">
    {{ i18n._711_NO_DATA_AVAILABLE | translate }}
</div>
<div
    class="table-responsive"
    *ngIf="!hasPendingData && data != null"
>
    <table class="table table-striped table-sm table-bordered-no-cells">
        <thead class="thead-light">
            <tr>
                <th>{{ i18n._127_STATUS | translate }}</th>
                <th *ngIf="isTeamMode">{{ i18n._778_PERSON | translate }}</th>
                <th>{{ i18n._713_METRIC | translate }}</th>
                <th>{{ i18n._767___TO_GOAL | translate }}</th>
                <th>{{ i18n._768___TO_TARGET | translate }}</th>
                <th>{{ i18n._746_DETAILS | translate }}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let i of data.items">
                <td class="text-center">
                    <!--TODO revise-->
                    <cmps-icon
                        svgIcon="check-circle-outline"
                        [title]="i18n._741_GOAL_MET | translate"
                        *ngIf="i.goalMet"
                    ></cmps-icon>
                    <cmps-icon
                        svgIcon="exclamation-thick"
                        [title]="i18n._769_NOT_MEETING_GOAL | translate"
                        *ngIf="!i.goalMet && i.pctTarget != null"
                    ></cmps-icon>
                    <cmps-icon
                        svgIcon="clock-outline"
                        [title]="i18n._770_GOAL___30_DAYS | translate"
                        *ngIf="i.isOld"
                    ></cmps-icon>
                </td>
                <td *ngIf="isTeamMode">{{ i.name }}</td>
                <td>{{ i.metricName }}</td>
                <td>
                    <span>{{
                        i.pctGoal == null ? '-' : (i.pctGoal | percent: '1.1-2')
                    }}</span>
                </td>
                <td>
                    <span>{{
                        i.pctTarget == null
                            ? '-'
                            : (i.pctTarget | percent: '1.1-2')
                    }}</span>
                </td>
                <td class="text-center">
                    <button
                        type="button"
                        class="cmps-btn-table"
                        role="link"
                        (click)="goToJournal(i.journalUrl)"
                    >
                        <cmps-icon svgIcon="folder-outline"></cmps-icon>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</div>
